import controller from './media.controller';
import template from './media.html';
import './media.scss';
/**
 * @ngdoc component
 * @name media
 * @description
 * The media component of the app.
 *
 * @memberof media
 */
export default {
  /**
   * The controller class for the component.
   * @type {MediaController}
   */
  controller,
  /**
   * The HTML template for the component.
   * @type {String}
   */
  template,
  /**
   * Component bindings
   * @type {Object}
   * @property {String} type        Where the media to be shown is coming from.
   * @property {String} mediaId     ID of the media to be shown.
   * @property {String} campaignId  ID of the campaign related to the media.
   */
  bindings: {
    type: '@',
    mediaId: '@',
    campaignId: '@',
  },
};



// WEBPACK FOOTER //
// ./src/frontend/modules/media/components/media/media.component.js